__webpack_require__.p = "/uic-datalabs-seminar/";